export default [
  {
    
    path: '/beforedata/:key?',
    name: 'beforedata',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/beforeData/BeforeData.vue'),
    meta: {},
  },
];
